module.exports = __webpack_public_path__ + "static/media/Test37.8b9811e5.bmp";